export const getId = state => state.id
export const getIsLogging = state => state.isLogging
export const getDidInvalidate = state => state.didInvalidate